module.exports = __webpack_public_path__ + "media/components/assets/img/bg/circle-d0e5e5e459f86211968a29e325d1d767.svg";